interface Params {
	amount?: number;
	abbreviated?: boolean;
	short?: boolean;
	numberWithCommas?: boolean;
	fullWords?: boolean;
	roundOff?: boolean;
	minimumFractionDigits?: number;
	maximumFractionDigits?: number;
	toFixedDigits?: boolean;
}

export default function currencify({
	amount,
	abbreviated,
	short,
	numberWithCommas,
	minimumFractionDigits = 0,
	maximumFractionDigits = 0,
	fullWords,
	roundOff = true,
	toFixedDigits = false,
}: Params = {}): string {
	if (!amount && amount !== 0) return "";
	if (abbreviated || short || toFixedDigits) {
		amount = Number(amount);
		// ensure 89.90 => 89.9, 89.00 => 89
		let roundOffAmt = parseFloat(
			(amount / 1000)
				.toFixed(2)
				.replace(/(\..)0$/, "$1")
				.replace(/(\.)0$/, ""),
		);
		if (roundOffAmt >= 100) {
			roundOffAmt = parseFloat(
				(roundOffAmt / 100)
					.toFixed(2)
					.replace(/(\..)0$/, "$1")
					.replace(/(\.)0$/, ""),
			);
			if (roundOffAmt >= 100) {
				roundOffAmt = parseFloat(
					(roundOffAmt / 100)
						.toFixed(2)
						.replace(/(\..)0$/, "$1")
						.replace(/(\.)0$/, ""),
				);
				if (short) return roundOffAmt + "C";
				return roundOffAmt + (roundOffAmt > 1 ? " Crores" : " Crore");
			}
			if (short) return roundOffAmt + "L";
			return roundOffAmt + (roundOffAmt > 1 ? " Lakhs" : " Lakh");
		}
		if (short) return roundOffAmt + "K";
		if (toFixedDigits) return Math.round(roundOffAmt) + " Thousands";
		return roundOffAmt + (roundOffAmt > 1 ? " Thousands" : " Thousand");
	}
	if (numberWithCommas) {
		const a = amount.toLocaleString("en-IN", {
			style: "currency",
			currency: "INR",
			maximumFractionDigits: Math.max(maximumFractionDigits, minimumFractionDigits),
			minimumFractionDigits,
		});
		return a.replace(/₹\s?/, "₹ ");
	}

	if (amount.toString().length > 9) return "overflow";

	if (fullWords) {
		const a = [
			"",
			"One ",
			"Two ",
			"Three ",
			"Four ",
			"Five ",
			"Six ",
			"Seven ",
			"Eight ",
			"Nine ",
			"Ten ",
			"Eleven ",
			"Twelve ",
			"Thirteen ",
			"Fourteen ",
			"Fifteen ",
			"Sixteen ",
			"Seventeen ",
			"Eighteen ",
			"Nineteen ",
		];
		const b = ["", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"];

		const inWords = (num: number) => {
			//valid upto 9 digits
			if (num.toString().length > 9) return "overflow";
			const n = ("000000000" + num).substr(-9).match(/^(\d{2})(\d{2})(\d{2})(\d{1})(\d{2})$/);
			if (!n) return "";
			let str = "";
			str += Number(n[1]) !== 0 ? (a[Number(n[1])] || b[Number(n[1][0])] + " " + a[Number(n[1][1])]) + "Crore " : "";
			str += Number(n[2]) !== 0 ? (a[Number(n[2])] || b[Number(n[2][0])] + " " + a[Number(n[2][1])]) + "Lakh " : "";
			str += Number(n[3]) !== 0 ? (a[Number(n[3])] || b[Number(n[3][0])] + " " + a[Number(n[3][1])]) + "Thousand " : "";
			str += Number(n[4]) !== 0 ? (a[Number(n[4])] || b[Number(n[4][0])] + " " + a[Number(n[4][1])]) + "Hundred " : "";
			str +=
				Number(n[5]) !== 0
					? (str !== "" ? "And " : "") + (a[Number(n[5])] || b[Number(n[5][0])] + " " + a[Number(n[5][1])]) + "Only"
					: "Only";
			return str;
		};
		return inWords(amount);
	}
	const n = ("000000000" + amount).substr(-9).match(/^(\d{2})(\d{2})(\d{2})(\d{1})(\d{2})$/);
	let str = "";
	if (!n) return str;

	if (Number(n[1]) !== 0) {
		str +=
			(Number(n[1]) < 10 ? n[1][1] : n[1][0] + n[1][1]) +
			(roundOff && Number(n[2]) !== 0 ? "." + (Number(n[2][1]) !== 0 ? n[2][0] + n[2][1] : n[2][0]) : "") +
			" Crore" +
			(Number(n[1]) > 1 ? "s" : "") +
			" ";
	}

	if (Number(n[2]) !== 0) {
		if (Number(n[1]) === 0 || !roundOff) {
			str +=
				(Number(n[2]) < 10 ? n[2][1] : n[2][0] + n[2][1]) +
				(roundOff && Number(n[1]) === 0 && Number(n[3]) !== 0
					? "." + (Number(n[3][1]) !== 0 ? n[3][0] + n[3][1] : n[3][0])
					: "") +
				" Lakh" +
				(Number(n[2]) > 1 ? "s" : "") +
				" ";
		}
	}

	if (!str || !roundOff) {
		str +=
			Number(n[3]) !== 0
				? (Number(n[3]) < 10 ? n[3][1] : n[3][0] + n[3][1]) + " Thousand" + (Number(n[3][1]) > 1 ? "s" : "") + " "
				: "";
		str += Number(n[4]) !== 0 ? n[4] + " Hundred" + (Number(n[4][1]) > 1 ? "s" : "") + " " : "";
		str += Number(n[5]) !== 0 ? (Number(n[5]) < 10 ? n[5][1] : n[5][0] + n[5][1]) : "";
	}
	return str;
}
